import { chartEmptyValueConstants } from '@/utils/reports/chartEmptyValueConstants';

const emptyKeyMap = {
  jobs_department_chart: 'department',
  jobs_location_chart: 'job_location',
};

/**
 * Transforms interview data for feedback and duration charts
 * @param response API response data
 * @param feedbackKeys keys for feedback metrics
 * @returns Object containing data for both charts
 */
export const jobsVisualsTransformer = ({ response, metadata }) => {
  const { table = [], lookups: { g1 = {}, g1_l2 = [] } = {} } = response || {};

  const { tileKey } = metadata || {};
  const emptyKey = emptyKeyMap[tileKey];

  const formattedData = table?.map((curr) => {
    const group = curr[2];
    const value = curr[4];
    if (Array.isArray(g1[group])) {
      const nameLookup = g1?.[group]?.map((g1) => g1_l2[g1]?.name);
      const idLookup = g1?.[group]?.map((g1) => g1_l2[g1]?.id);
      return { value, name: nameLookup?.join(','), id: idLookup?.join(',') };
    }

    if (typeof g1[group] === 'object') {
      return { value, ...g1[group] };
    }
    return { value, key: g1[group] };
  }, []);

  const result = formattedData?.map((x) => {
    return {
      name: x?.name || chartEmptyValueConstants[emptyKey] || 'Not found',
      y: x?.value,
      g1:
        tileKey === 'jobs_location_chart'
          ? x?.id?.split(',')?.map(Number) || null
          : x?.id || null,
    };
  });

  const categories = result.map((item) => item.name);

  return {
    series: result,
    categories, // For bar/column charts
  };
};
